import MfaEnrollment from './MfaEnrollment';

export { default as MfaEnrollmentBanner } from './MfaEnrollmentBanner';

export default MfaEnrollment;
